import { IconCheck } from '@shared/ui/icons';
import { TextButton } from '@widgets/FleetRegistry/ui';
import type { PositionSave } from '../usePositionSaver';
import { SaveLine } from './styles';

export function SaveStatus({
  state,
  onRetry,
  onReread,
}: {
  state: PositionSave | undefined;
  onRetry: () => void;
  onReread: () => void;
}) {
  if (!state) return null;
  if (state.phase === 'pending') return <SaveLine>Сохраняю…</SaveLine>;
  if (state.phase === 'saved') {
    return (
      <SaveLine>
        <IconCheck size={14} />
        Сохранено
      </SaveLine>
    );
  }
  return (
    <SaveLine $error role="alert">
      <span>{state.message}</span>
      {state.stale ? (
        <TextButton type="button" onClick={onReread}>
          Перечитать
        </TextButton>
      ) : (
        <TextButton type="button" onClick={onRetry}>
          Повторить
        </TextButton>
      )}
    </SaveLine>
  );
}
